import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import SignIn from './components/auth/SignIn';
import Dashboard from './components/layout/Dashboard';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Customers from './pages/customers/customers';
import { colors } from './utils/colors';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary.main, 
    },
    secondary: {
      main: colors.secondary.main, 
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<SignIn />} />
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/customers" 
              element={
                <ProtectedRoute>
                  <Dashboard defaultSection="customers" />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/customers/:id/*" 
              element={
                <ProtectedRoute>
                  <Dashboard defaultSection="customers" />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/edit-customer/:id" 
              element={
                <ProtectedRoute>
                  <Dashboard defaultSection="customers" />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/subscriptions"
              element={
                <ProtectedRoute>
                  <Dashboard defaultSection="subscriptions" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Dashboard defaultSection="reports" />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;


